// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__f8NXu","row":"Tooltip_row__u7FH8","label":"Tooltip_label__iY1FD","value":"Tooltip_value__jumdb"};